module.exports = __webpack_public_path__ + "static/media/hyperloop-russia.dc55d26d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/hyperloop-russia.jpg
// module id = 351
// module chunks = 0